import { graphql } from 'react-relay';

const query = graphql`
  query updateStatusQuery($packageId: Int!) {
    privatePackageTracker(packageId: $packageId) {
      currentStatus {
        error
        inProgress
        destination
      }
      relativeEta
      currentDriverPosition {
        lat
        lng
      }
      driverInfo {
        firstName
        photoUrl {
          default
        }
      }
    }
  }
`;

export default query;
